<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right">Công ty<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn công ty" cusClass="text-box m-0" width="100%" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'" @scroll="emitEvent"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Bộ phận</label>
          <DropdownScrollable
          placeholder="Chọn"
          :showClear="false"
          cusClass="text-box"
          width="100%"
          :multiple="false"
          :limit="department_obj.limit"
          :loading="department_obj.loading"
          v-model="department"
          :options="department_obj.items"
          :total="department_obj.total"
          onlyClick
          @scroll="emitEventDepartment"
          @offset="changeOffsetDepartment"
          />
          <input class="input_tmp_validator" id="department" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Tên công việc<span class="required"></span></label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <form id="frm_action_1">
        <div class="mt-3">
          <label class="txt-right">DANH SÁCH TÌNH HUỐNG CÓ THỂ XẢY RA</label>
        </div>
        <div class="mt-3">
          <label class="txt-right">Tên tình huống<span class="required"></span></label>
          <InputText
            v-model="name_situation"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name_situation" />
        </div>
        <div class="mt-3">
          <Checkbox v-model="active_situation" :binary="true" /> Hiển thị tình huống này
        </div>
        </form>
        <div class="mt-3">
          <Button
            v-if="$store.getters.controllers?.list_situation && $store.getters.controllers?.list_situation.includes('add')"
            @click="AddSituation()"
            icon="pi pi-plus"
            class="button-box-1 p-button-add"
          />
        </div>
        <div class="mt-3">
          <table id="tb_level">
            <tr>
              <th style="width: 60px;">STT</th>
              <th>Tình huống</th>
              <th style="width: 110px;">Trạng thái</th>
              <th style="width:90px">Hiển thị</th>
              <th style="width: 85px;"></th>
            </tr>
            <tr v-for="(item, index) in situation" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.status_text}}</td>
              <td style="text-align: center;"><span v-html="item.active_text"></span></td>
              <td>
                <Button v-if="item.status=='APPROVED' && $store.getters.controllers?.list_situation && $store.getters.controllers?.list_situation.includes('edit')"
                  @click="EditItem(index)"
                  icon="pi pi-pencil"
                  class="button-box p-button-edit"
                >
                </Button>
                <Button v-if="item.status=='WAITTING' && $store.getters.controllers?.list_situation && $store.getters.controllers?.list_situation.includes('edit')"
                  @click="ApprovedItem(index)"
                  icon="pi pi-pencil"
                  class="button-box"
                ><i style ="" class="material-icons material-icons-cus">published_with_changes</i>
                </Button>
                <Button
                  v-if="$store.getters.controllers?.list_situation && $store.getters.controllers?.list_situation.includes('delete')"
                  @click="showDeleteData(index)"
                  icon="pi pi-trash"
                  class="button-box p-button-danger"
                />
          </td>
            </tr>
          </table>
        </div>
        <div class="mt-3">
          <Checkbox v-model="active" :binary="true" /> Hiển thị công việc
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
    <Dialog
    style=""
    header="Cập nhật"
    :visible.sync="showEditDialog"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
      <div class="">
        <label class="txt-right">Tên tình huống<span class="required"></span></label>
        <InputText
          v-model="item_edit.name"
          type="text"
          class="text-box-dialog input-text-box"
          placeholder="Nhập"
          maxlength="255"
        />
        <input class="input_tmp_validator" id="name_danger_edit" />
      </div>
      <div class="">
        <Checkbox v-model="item_edit.active" :binary="true" /> Hiển thị tình huống này
      </div>
      
    <template
      #footer
    >
      <Button label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
      <Button
        label="Hủy"
        @click="showEditDialog = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
    </template>
  </Dialog>
  <Dialog
    style=""
    header="Xóa"
    :visible.sync="showDelete"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
    Bạn có chắc muốn xoá tình huống này không?
    <template #footer>
      <Button label="Xác nhận" @click="deleteItem()" icon="pi pi-check" class="" />
      <Button
        label="Hủy"
        @click="showDelete = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
    </template>
  </Dialog>
  <Dialog
    header="Duyệt tình huống"
    :visible.sync="showApprovedDialog"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
      <div style="max-width:500px">
        <span>Tình huống này được tạo khi đánh giá. Sau khi duyệt, tình huống này sẽ được hiển thị cho toàn bộ người dùng trong công ty. Bạn có chắc muốn duyệt tình huống này không?</span>
      </div>
      <div style="display: flex;width:auto;max-width:500px;padding-bottom:7px;padding-top:2px;">
        <!-- <i style ="color:#0086c4" class="material-icons material-icons-cus">factory</i> -->
        <svg width="20px" height="20px" viewBox="0 -960 960 960" fill="#0086c4" stroke="#0086c4"><path stroke="#0086c4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M80-80v-481l280-119v80l200-80v120h320v480H80Zm80-80h640v-320H480v-82l-200 80v-78l-120 53v347Zm280-80h80v-160h-80v160Zm-160 0h80v-160h-80v160Zm320 0h80v-160h-80v160Zm280-320H680l40-320h120l40 320ZM160-160h640-640Z"/></svg>
        <span style="margin-left: 5px;color:#666666">{{text_approved}}</span>
      </div>
      <div class="">
        <!-- <label class="txt-right">Tên tình huống<span class="required"></span></label> -->
        <InputText
          v-model="item_approved.name"
          type="text"
          class="text-box-dialog input-text-box"
          placeholder="Nhập"
          maxlength="255"
        />
        <input class="input_tmp_validator" id="name_danger_approved" />
      </div>
    <template
      #footer
    >
      <Button
        label="Hủy"
        @click="showApprovedDialog = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
      <Button label="Chỉ lưu" @click="ApprovedData('save')" icon="pi pi-check" class="" />
      <Button label="Lưu & duyệt" @click="ApprovedData('save_approved')" icon="pi pi-check" class="" />
    </template>
  </Dialog>
  </form>
  
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  components: {
    DropdownScrollable
  },
  data() {
    return {
      text_approved : "",
      filters: {},
      name: "",
      code: "",
      name_situation: "",
      active_situation: true,
      point : null,
      situation : [],
      type_login : this.$store.getters.type ? this.$store.getters.type : null,
      situation_deleted : [],
      showEditDialog : false,
      showApprovedDialog : false,
      item_edit : {
        id: null,
        name: "",
        active: "",
        status : "",
        index : null,
        is_old : true,
      },
      item_approved : {},
      company : null,
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      active: true,
      listSituation : [],
      selSituation : null,
      showDelete : false,
      index_deleted : false,
      listDepartment : [],
      selDepartment : null,
      company_old : null,
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department : null
    };
  },
  async mounted() {
    if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
      await this.getListCompany();
    }
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.company = this.model.company;
      this.company_old = this.model.company;
      await this.getListCategory()
      await this.getListDepartment();
      this.name = this.model.name;
      this.code = this.model.code;
      if(this.model.department){
        this.department = this.model.department
      }
      var tmp = this.model.situation;
      console.log("tmp==",tmp)
      var count = tmp.length
      for (let i = 0; i < tmp.length; i++) {
        tmp[i].is_old = true
        tmp[i].ordinal = count-1
        count--
        if(tmp[i].status == 'APPROVED'){
          tmp[i].status_text = 'Đã duyệt'
          if(tmp[i].active == true){
            tmp[i].active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            tmp[i].active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          tmp[i].status_text = 'Chưa duyệt'
          tmp[i].active_text =''
        }
      }
      this.situation = tmp
      this.active = this.model.active;
      
    }else{
      if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = {id : this.$store.getters?.company_id}
      }
    }
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        console.log("this.companythis.companythis.company", this.company);
        await this.getListDepartment();
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
        console.log("this.companythis.companythis.company", this.company);
        await this.getListDepartment();
      }
    },
    async "company"() {
      await this.clearChangeCompany()
      await this.getListDepartment();
    }
  },
  methods: {
    async clearChangeCompany(){
      this.department_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.department = null
    },
    emitEventDepartment(keyword) {
      console.log(keyword);
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.department_obj.loading = true;
        this.department_obj.filters.active = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.total;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    async getListDangerEvent(event) {
      console.log(event);
      await this.getListDanger()
    },
    getCompany(value) {
      this.company = value;
    },
    changeOffset(value) {
      this.company_obj.offset = value;
    },
    async emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.company_old =null
      this.selDepartment = null,
      this.listDepartment = []
      await this.getListCompany();
    },
    async emitEventData(){
      if(this.company_old && this.company && this.company_old.id == this.company?.id){
        return;
      }
      this.company_old = {id : this.company.id}
      await this.getListDepartment();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
              this.company_obj.items.push(...res.data.data.company);
            } else{
              this.company_obj.items = res.data.data.company;
            }
            this.company_obj.total = res.data.data.count;
            this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    EditItem(index){
      const situation = this.situation[index];
      this.item_edit = {
        id : situation.id,
        name: situation.name,
        status: situation.status,
        active : situation.active,
        is_old : situation.is_old,
        index : index,
        ordinal : situation.ordinal,
      }
      this.showEditDialog = true
    },
    async validateDataApproved() {
      let name_danger_approved = document.getElementById("name_danger_approved");
      if (this.item_approved.name == undefined || this.item_approved.name == null || this.item_approved.name == "") {
        name_danger_approved.setCustomValidity("Tên tình huống không được để trống!");
      } else if (this.item_approved.name.length > 255) {
        name_danger_approved.setCustomValidity("Tên tình huống không được quá 255 ký tự!");
      } else {
        name_danger_approved.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async ApprovedData(save){
      this.$commonFuction.is_loading(true);
      if (await this.validateDataApproved()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var objects = {
        company_id : company_id,
        id : this.item_approved.id,
        name : this.item_approved.name,
        save : save,
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      const headers = {
        "Authorization": "Bearer "+token,
      };
      var that = this
      await ApiRepository.post("/_api/situation/change", objects, {headers}).then(async function (response) {
        if (response.status === 200) {
          await that.getDataList();
          that.toastSuccess('Lưu dữ liệu thành công')
          that.showApprovedDialog = false
          that.$commonFuction.is_loading(false);
        } else {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: response.data.message,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        }
      }).catch((err) => {
        that.$toast.add({
          severity: 'error',
          summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: err,
          life: 3000
        });
        that.$commonFuction.is_loading(false);
      })
    },
    toastSuccess(text){
      this.$commonFuction.is_loading(false);
      this.$toast.add({ severity: 'success', summary: 'Success', detail: text, life: 3000 })
    },
    async getDataList(){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var list = []
      var filters = {id : this.model.id}
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id && filters.id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/work/situation", {filters,limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
          var data = response.data.data;
          list = data.list;
        })
      }
      var count = list.length
      for (let i = 0; i < list.length; i++) {
        list[i].is_old = true
        list[i].ordinal = count-1
        count--
        if(list[i].status == 'APPROVED'){
          list[i].status_text = 'Đã duyệt'
          if(list[i].active == true){
            list[i].active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            list[i].active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          list[i].status_text = 'Chưa duyệt'
          list[i].active_text =''
        }
      }
      this.situation = list
    },
    async ApprovedItem(index){
      const situation = this.situation[index];
      this.item_approved = {
        id : situation.id,
        name: situation.name,
        status: situation.status,
        active : situation.active,
        is_old : situation.is_old,
        index : index
      }
      await this.infoSituation(situation.id)
      this.showApprovedDialog = true
    },
    async infoSituation(id){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      // console.log("this.company",this.company)
      var text = this.company?.name
      if(token && company_id && id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/situation/detail", {situation_id: id,company_id: company_id}, {headers}).then(async function (response) {
          var data = response.data.data;
          if(data.evaluation_form){
            text += ' / '+data.evaluation_form.name
            if(data.evaluation_form.department){
              text += ' / '+data.evaluation_form.department.name
            }
          }
        })
      }
      this.text_approved = text
    },
    async getListDanger(){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listDanger = []
      var filters = {active:true,status : "APPROVED"}
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id && filters.category_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/danger/options", {filters,limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
            var data = response.data.data;
            listDanger = data.list;
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
        this.selDanger = null
        this.listDanger = listDanger
      }

    },
    async getListCategory(){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listCategory = []
      // var total = 0;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/category/options", {limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
            var data = response.data.data;
            listCategory = data.list;
            // total = data.count;
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
        this.listCategory = listCategory
      }
    },
    async EditData(){
      this.item_edit.name.trim();
      if (await this.validateDataEdit()) {
        return;
      }
      if(this.item_edit.index >= 0){
        var active_text = ''
        var status_text = ''
        if(this.item_edit.status == 'APPROVED'){
          status_text = 'Đã duyệt'
          if(this.item_edit.active == true){
            active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          status_text = 'Chưa duyệt'
          active_text =''
        }
        this.situation[this.item_edit.index] = {
          "id" : this.item_edit.id,
          "name" : this.item_edit.name,
          "active" : this.item_edit.active,
          "status" : this.item_edit.status,
          "is_old" : this.item_edit.is_old,
          "ordinal" : this.item_edit.ordinal,
          "active_text" : active_text,
          "status_text" : status_text,
        }
        this.showEditDialog = false
      }
      
    },
    async AddSituation(){
      this.name_situation.trim()
      //check validate
      if (await this.validateDataAdd()) {
        return;
      }
      // var tmp = this.situation
      var status_text = "Đã duyệt"
      var active_text = ``
      if(this.active_situation == true){
        active_text = `<i class="pi pi-check success bold"></i>`
      }else{
        active_text = `<i class="pi pi-times danger bold"></i>`
      }
      var count = this.situation.length
      this.situation.push({
        is_old : false,
        id: null,
        name: this.name_situation,
        status: 'APPROVED',
        active: this.active_situation,
        status_text : status_text,
        active_text : active_text,
        ordinal : count
      })
      this.name_situation = ''
      this.active_situation = true
    },
    sortDataV2(data){
      var status_w = []
      var status_a = []
      for (let i = 0; i < data.length; i++) {
        if(data[i].status == 'WATTING'){
          status_w.push(data[i])
        }else{
          status_a.push(data[i])
        }
      }
      status_w = this.sortData(status_w,'ordinal','desc')
      status_a = this.sortData(status_a,'ordinal','desc')
      var tm = [...status_w,...status_a]
      this.danger = tm
    },
    sortData(arr,key,sort='desc'){
      if(sort == 'desc'){
        return arr.slice().sort(function(a, b) {
          return b[key] - a[key];
        });
      }else{
        return arr.slice().sort(function(a, b) {
          return a[key] - b[key];
        });
      }
    },
    async validateDataAdd() {
      if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
        let company_add = document.getElementById("company");
        company_add.setCustomValidity("");
      }
      let department = document.getElementById("department");
      department.setCustomValidity("");
      let name = document.getElementById("name");
      name.setCustomValidity("");

      let name_situation = document.getElementById("name_situation");
      if (this.name_situation == undefined || this.name_situation == null || this.name_situation == "") {
        name_situation.setCustomValidity("Tên tình huống không được để trống!");
      } else if (this.name_situation.length > 255) {
        name_situation.setCustomValidity("Tên tình huống không được quá 255 ký tự!");
      }else if(this.name_situation.toLowerCase() == 'khác'){
        name_situation.setCustomValidity("Tên tình huống đã tồn tại trên hệ thống");
      }else{
        var check_exs = false
        for (let i = 0; i < this.situation.length; i++) {
          if(this.situation[i].name.toLowerCase() == this.name_situation.toLowerCase()){
            check_exs = true;
            break;
          }
        }
        if(check_exs == true){
          name_situation.setCustomValidity("Tên tình huống đã tồn tại!");
        }else{
          name_situation.setCustomValidity("");
        }
      }
      var inpObj = document.getElementById("frm_action_1");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async validateDataEdit() {
      let name_danger_edit = document.getElementById("name_danger_edit");
      if (this.item_edit.name == undefined || this.item_edit.name == null || this.item_edit.name == "") {
        name_danger_edit.setCustomValidity("Tên tình huống không được để trống!");
      } else if (this.item_edit.name.length > 255) {
        name_danger_edit.setCustomValidity("Tên tình huống không được quá 255 ký tự!");
      } else {
        name_danger_edit.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    showDeleteData(index){
      this.showDelete = true
      this.index_deleted = index
    },
    async checkDeleteData(id){
      //kiểm tra có tồn tại trong phiếu đánh giá k?
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/situation/check_delete_data", {situation_id:id,company_id: company_id}, {headers});
        var value = data.data;
        console.log("+=====",value)
        if(value){
          return true
        }
        return false
      }
    },
    deleteItem() {
      var index = this.index_deleted
      var situation = this.situation[index];
      console.log("situation==",situation)
      if(situation.id){
        if(this.checkDeleteData(situation.id)){
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: 'Tình huống đã tồn tại trong phiếu đánh giá.',
            life: 20000
          });
          this.showDelete = false
          return
        }
        this.situation_deleted.push(situation.id)
      }
      this.showDelete = false
      this.situation.splice(index, 1)
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};
      if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let department = document.getElementById("department");
      if (
        this.$commonFuction.isEmptyObject(this.department) ||
        this.$commonFuction.isEmpty(this.department)
      ) {
        department.setCustomValidity("Bộ phận không được để trống!");
      } else {
        department.setCustomValidity("");
      }

      let name = document.getElementById("name");
      if (this.name == undefined || this.name == null || this.name == "") {
        name.setCustomValidity("Tên công việc không được để trống!");
      } else if (this.name.length > 255) {
        name.setCustomValidity("Tên công việc không được quá 255 ký tự!");
      } else {
        name.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if(this.situation.length == 0){
        alert("Vui lòng thêm ít nhất một tình huống");
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        company: this.company,
        name: this.name,
        department : this.department,
        situation: this.situation,
        active: this.active
      };
      console.log("saveData", params);
      this.$emit("save", params);

    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.button-box {
  /* min-height: 45px !important; */
  width: 30px !important;
  height: 30px;
  margin-left : 2px;
}
.button-box-1 {
  /* min-height: 45px !important; */
  /* width: 4% !important;
  height: 45px; */
  width : 34px !important;
  margin-left : 6px;
}
.number-box {
  display: block;
  // min-height: 48px !important;
  width: 46% !important;
}
.text-box-dialog {
  display: block;
  // min-height: 48px !important;
  min-width: 400px;
}
.number-text-box {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
  /* padding-left: 10px !important; */
}
/**css table */
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel{
  background: #FFFAF0;
  border: 1px solid #d0dde7;
  color : #000000
}
.material-icons-cus{
  font-size : 19px !important;
}
/**end css table */
</style>
